import { QuizImportMethods } from '@showbie-socrative/socrative-utils/lib/consts/enums';

import axios from '../../localAxios';
import { extractSocNumber } from '../../utils/extractSocNumber';
import { importQuizBySocURL } from '../url';

export interface ImportQuizBySocParams {
  parentId: number;
  socNumber: string;
  importMethod: QuizImportMethods;
}

export interface ResponseBody {
  createById: number;
  id: number;
  sharable: boolean;
  isHidden: boolean;
  createdDate: string;
  name: string;
  lastUpdated: string;
  socNumber: string;
  originalSocNumber?: string;
  version: number;
  parentId: null;
  date: string;
  soc: string;
  deleted: boolean;
}

export async function importQuizToPersonalBySoc({
  parentId,
  socNumber,
  importMethod,
}: ImportQuizBySocParams) {
  const socCode = extractSocNumber(socNumber);

  const url = importQuizBySocURL(importMethod);
  const response = await axios.post<ResponseBody>(url.href, {
    parentId: parentId,
    socNumber: socCode,
  });

  response.data.originalSocNumber = socCode;
  return response.data;
}
